import { LocalStorageConstants } from "../constants/LocalStorageConstants";

export const getAuthTokens = () => {
  const oktaTokenStr = localStorage.getItem(LocalStorageConstants.OKTA_TOKEN) || '{"accessToken": "", "idToken": "" }';

  return JSON.parse(oktaTokenStr);
};
